import React from 'react';
import {
  Box,
  Typography,
  Tabs,
  Tab
} from '@mui/material';

const BookingTabs = ({
  currentTab,
  onTabChange,
  getBookingsByStatus,
  getUpcomingBookings,
  getPastBookings,
  filterBookings,
  searchTerm,
  autoConfirmBookings = false
}) => {
  // Calculate filtered counts for display - only apply filtering for history tab
  const getFilteredCount = (bookingsList, isHistoryTab = false) => {
    if (!isHistoryTab || !filterBookings || !searchTerm) {
      // Debug: log the bookings to understand what's happening
      if (isHistoryTab) {
        console.log('🔍 Debug - Past bookings:', bookingsList);
        console.log('🔍 Debug - Search term:', searchTerm);
        console.log('🔍 Debug - Total past bookings count:', bookingsList.length);
      }
      return bookingsList.length;
    }
    const filtered = filterBookings(bookingsList, searchTerm);
    console.log('🔍 Debug - Filtered past bookings:', filtered);
    console.log('🔍 Debug - Filtered count:', filtered.length);
    return filtered.length;
  };

  // Create tabs array based on autoConfirmBookings setting
  const tabs = [];
  
  // Only show "En attente" tab if auto-confirm is disabled
  if (!autoConfirmBookings) {
    tabs.push({
      key: 'pending',
      label: (
        <Box textAlign="center">
          <Typography
            variant="h6"
            fontWeight="700"
            color="warning.main"
            sx={{ fontSize: { xs: '1rem', sm: '1.25rem' } }}
          >
            {getBookingsByStatus('pending').length}
          </Typography>
          <Typography
            variant="caption"
            sx={{ fontSize: { xs: '0.7rem', sm: '0.75rem' } }}
          >
            En attente
          </Typography>
        </Box>
      )
    });
  }
  
  // Always show "À venir" tab
  tabs.push({
    key: 'upcoming',
    label: (
      <Box textAlign="center">
        <Typography
          variant="h6"
          fontWeight="700"
          color="success.main"
          sx={{ fontSize: { xs: '1rem', sm: '1.25rem' } }}
        >
          {getUpcomingBookings().length}
        </Typography>
        <Typography
          variant="caption"
          sx={{ fontSize: { xs: '0.7rem', sm: '0.75rem' } }}
        >
          À venir
        </Typography>
      </Box>
    )
  });
  
  // Always show "Historique" tab
  tabs.push({
    key: 'history',
    label: (
      <Box textAlign="center">
        <Typography
          variant="h6"
          fontWeight="700"
          color="text.secondary"
          sx={{ fontSize: { xs: '1rem', sm: '1.25rem' } }}
        >
          {getFilteredCount(getPastBookings(), true)}
        </Typography>
        <Typography
          variant="caption"
          sx={{ fontSize: { xs: '0.7rem', sm: '0.75rem' } }}
        >
          Historique
        </Typography>
      </Box>
    )
  });

  return (
    <Box sx={{ bgcolor: 'white', borderRadius: '20px 20px 0 0', mt: -2, position: 'relative', zIndex: 10 }}>
      <Tabs
        value={currentTab}
        onChange={onTabChange}
        variant="fullWidth"
        sx={{
          '& .MuiTab-root': {
            textTransform: 'none',
            fontWeight: 600,
            py: { xs: 1.5, sm: 2 },
            fontSize: { xs: '0.8rem', sm: '0.9rem' },
            minHeight: { xs: 60, sm: 72 }
          },
          '& .MuiTabs-indicator': {
            height: 4,
            borderRadius: '4px 4px 0 0',
            background: 'linear-gradient(135deg, #1c1917 0%, #44403c 100%)'
          }
        }}
      >
        {tabs.map((tab, index) => (
          <Tab key={tab.key} label={tab.label} />
        ))}
      </Tabs>
    </Box>
  );
};

export default BookingTabs;